import types from '../types'

const configReceived = (response, extraParams) => ({
  type: types.CONFIG_RECEIVED,
  payload: response.data,
  extraParams,
})

const configFailed = () => ({
  type: types.CONFIG_FAILED,
})

export default {
  configReceived,
  configFailed,
}
